/**
 * Breakpoints by Spectre
 * {@link} https://picturepan2.github.io/spectre/layout/responsive.html
 */
export const XSMALL = '(max-width: 480px)';
export const SMALL = '(min-width: 481px) and (max-width: 600px)';
export const MEDIUM = '(min-width: 601px) and (max-width: 840px)';
export const LARGE = '(min-width: 841px) and (max-width: 960px)';
export const XLARGE = '(min-width: 961px) and (max-width: 1280px)';
export const XXLARGE = '(min-width: 1281px)';

export const MIN_SMALL = '(min-width: 481px)';
export const MIN_MEDIUM = '(min-width: 601px)';
export const MIN_LARGE = '(min-width: 841px)';
export const MIN_XLARGE = '(min-width: 961px)';
export const MIN_XXLARGE = '(min-width: 1281px)';

export const MAX_SMALL = '(max-width: 600px)';
export const MAX_MEDIUM = '(max-width: 840px)';
export const MAX_LARGE = '(max-width: 960px)';
export const MAX_XLARGE = '(max-width: 1280px)';
export const MAX_XXLARGE = '(max-width: 1440px)';
